import { useQuery } from "react-query";
import { getOfficeOrigin } from "../../../../../actions/Utilities/OfficeOrigin";

export default function useOfficeOrigin() {
  const {data, isFetching} = useQuery("GetOfficeOrigin", getOfficeOrigin, {
    refetchOnWindowFocus: false,
  });
  return {data, isFetching};
}
